/**
 * @file checkbox.component.tsx
 * @description Компонент обертка для работы с @consta/uikit/Checkbox.
 * @author Genotroid
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies [@consta/uikit/Checkbox]
 */

import { Checkbox as ConstaCheckbox } from '@consta/uikit/Checkbox';

/**
 * Props для компонента Checkbox
 */
export interface ICheckboxProps extends Omit<React.ComponentProps<typeof ConstaCheckbox>, 'checked' | 'onChange'> {
    /** Текущее состояние чекбокса (отмечен/не отмечен) */
    value: boolean;
    /** Callback функция вызываемая при изменении состояния чекбокса */
    onChange: (value: boolean) => void;
}

export const Checkbox = ({ value = false, onChange, ...props }: ICheckboxProps) => {
    return <ConstaCheckbox size="s" onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.checked)} checked={value} {...props} />;
};
